// extracted by mini-css-extract-plugin
export default {"logo":"signIn_logo__K3lfu","socialBtns":"signIn_socialBtns__+rwYT"};